export default __webpack_public_path__ + "static/media/feature_engineering.d48a71a7.svg";